<template>
  <v-expansion-panel class="mb-3 rounded">
    <v-expansion-panel-header class="title font-weight-bold" @click="handleSetUrl" :id="`job_${job.id}`">
      <template v-slot:actions>
        <v-icon size="32" color="secondary">mdi mdi-chevron-down</v-icon>
      </template>
      <div>
        <div class="title-2">{{job.name}}</div>
        <div class="grey--text text--darken-1 subtitle-2">{{job.location}}</div>
        <div class="grey--text text--darken-1 subtitle-2">{{ $t('public_job_ads.search_ends') }}: {{
          $formatDateNoTime(job.searchEndDate) }}
        </div>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row class="px-6" v-if="$vuetify.breakpoint.smAndDown">
        <v-col cols="12">
          <v-btn color="primary"
                 :block="$vuetify.breakpoint.smAndDown"
                 class="accent-2--text"
                 @click="handleApplyJob">
            {{ $t('public_job_ads.apply_job') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row :no-gutters="$vuetify.breakpoint.smAndDown">
        <v-col cols="12" md="7" lg="8" :class="$vuetify.breakpoint.smAndDown ? 'py-3 px-6' : ''">
          <v-row v-if="job.imageKey">
            <v-col cols="12">
              <v-img :src="$getImageUrl(job.imageKey)" contain/>
            </v-col>
          </v-row>
          <div v-html="job.description" style="white-space: pre-line;"></div>
          <v-row v-if="job.linkDescription">

          </v-row>
          <v-row v-if="job.link">
            <v-col cols="12"/>
            <v-col cols="12" v-if="job.linkDescription">
              {{job.linkDescription}}
            </v-col>
            <v-col cols="12">
              <a v-if="job.link" :href="job.link">{{job.link}}</a>
            </v-col>
          </v-row>
          <v-row v-if="youtubeEmbedUrl">
            <v-col cols="12"/>
            <v-col cols="12" v-if="job.youtubeLinkDescription">
              {{job.youtubeLinkDescription}}
            </v-col>
            <v-col cols="12">
              <iframe :src="youtubeEmbedUrl"
                      style="width: 100%; height:400px; border: 0;"
                      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
              </iframe>
            </v-col>
          </v-row>

          <v-row v-if="job.customerImageKey && $vuetify.breakpoint.smAndDown">
            <v-col cols="12">
              <v-img class="mb-4" :src="$getImageUrl(job.customerImageKey)" contain
                     style="max-height: 100px; text-align: left"/>
            </v-col>
          </v-row>
          <v-btn color="primary"
                 v-if="$vuetify.breakpoint.smAndDown"
                 block
                 class="accent-2--text mb-4"
                 @click="handleApplyJob">
            {{ $t('public_job_ads.apply_job') }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="5" lg="4">

          <v-row v-if="job.customerImageKey && $vuetify.breakpoint.mdAndUp">
            <v-col cols="12">
              <v-img class="mb-4" :src="$getImageUrl(job.customerImageKey)" contain
                     style="max-height: 100px; text-align: left"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" order="0">
              <v-btn color="primary"
                     v-if="$vuetify.breakpoint.mdAndUp"
                     block
                     class="accent-2--text mb-4"
                     @click="handleApplyJob">
                {{ $t('public_job_ads.apply_job') }}
              </v-btn>
            </v-col>

            <v-col cols="12" order="1" order-md="0">
              <div :class="$vuetify.breakpoint.smAndDown ? 'rounded-b' : 'rounded mb-4'"
                   class="py-3 px-6 white--text accent-3">
                <div v-if="job.industry && job.industry.name">
                  <strong>{{ $t('public_job_ads.industry') }}:</strong> {{job.industry.name}}
                </div>
                <div>
                  <strong>{{ $t('public_job_ads.work_length') }}:</strong> {{job.length}}
                </div>
                <div>
                  <strong>{{ $t('public_job_ads.location') }}:</strong> {{job.location}}
                </div>
                <div>
                  <strong>{{ $t('public_job_ads.work_starts') }}:</strong> {{job.starts}}
                </div>
                <div>
                  <strong>{{ $t('public_job_ads.salary') }}:</strong> {{job.salary}}
                </div>
                <div v-if="job.positions">
                  <strong>{{ $t('public_job_ads.positions') }}:</strong> {{job.positions}}
                </div>
              </div>
            </v-col>

            <v-col cols="12" order="0" order-md="1" v-if="job.contactName">
              <div :class="$vuetify.breakpoint.smAndDown ? 'pb-6' : 'rounded grey lighten-4'" class="py-3 pl-6 pr-6">
                <v-list-item class="pa-0">
                  <v-list-item-content>
                    <div class="subtitle-1">{{ $t('public_job_ads.additional_info_from_position') }} <br
                        v-if="!job.contactImageKey"/> <strong>{{ job.contactName }}</strong></div>
                  </v-list-item-content>
                  <v-list-item-avatar v-if="job.contactImageKey" class="ml-0" size="70" color="white">
                    <v-avatar size="70">
                      <v-img :src="$getImageUrl(job.contactImageKey)"/>
                    </v-avatar>
                  </v-list-item-avatar>
                </v-list-item>
                <div>
                  <v-btn v-if="job.contactEmail" outlined block small color="secondary" class="mt-2 mb-2"
                         :href="`mailto:${job.contactEmail}`">
                    <v-icon left small>mdi mdi-email</v-icon>
                    {{ job.contactEmail }}
                  </v-btn>
                  <v-btn v-if="job.contactPhone" outlined block small color="secondary"
                         :href="`tel:${job.contactPhone}`">
                    <v-icon left small>mdi mdi-phone</v-icon>
                    {{ job.contactPhone }}
                  </v-btn>
                </div>
              </div>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
  name: 'JobExpansionPanel',
  props: {
    job: {},
  },
  methods: {
    handleApplyJob() {
      this.$emit('apply-job', this.job.id);
    },
    handleSetUrl() {
      this.$emit('set-url', this.job.id);
    }
  },
  computed: {
    youtubeEmbedUrl() {
      if (!this.job.youtubeLink) {
        return '';
      }
      const youtubeEmbedTemplate = 'https://www.youtube.com/embed/';
      const url = this.job.youtubeLink.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      const YId = undefined !== url[2] ? url[2].split(/[^0-9a-z_/\\-]/i)[0] : url[0];
      if (YId === url[0]) {
        console.log("not a youtube link");
        return '';
      } else {
        return youtubeEmbedTemplate.concat(YId);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1200px) {
}
</style>
<style lang="scss">

@media only screen and (min-width: 960px) {
}
</style>
